export default __webpack_public_path__ + "static/article-renovation-extravagant-2e5807a58cb4c88e1d34e8d87c4964fe.jpg";